import {FormError} from "@/components/ui/forms/FormError";
import {
  callRequest,
  clearForm,
  setAgree,
  setEmail,
  setError,
  setName,
  setPhone,
  setTime,
} from "@/redux/slices/commonSlices/requestSlice";

import {useEffect} from "react";

import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {SuccessSendPopup} from "@popups/attentionPopups/SuccessSendPopup";
import {RootButton} from "@ui/buttons/RootButton";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {Spinner} from "@ui/general/Spinner";
import {RootCheckbox} from "@ui/inputs/RootCheckbox";
import {RootInput} from "@ui/inputs/RootInput";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";
import PhoneInput from "react-phone-input-2";
import ru from "react-phone-input-2/lang/ru.json";
import "react-phone-input-2/lib/style.css";
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";

import styles from "./styles.module.scss";

export const CallPopup = () => {
  const {language} = useSelector((state) => state.common.settings);
  const {name, phone, email, time, agree, error, status} = useSelector(
    (state) => state.common.request,
  );
  const {openPopup} = usePopup();
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const {closePopup} = usePopup();

  const switchLanguage = (lang) => {
    switch (lang) {
      case "ru":
        return ru;
      case "en":
        return "";
      default:
        return "";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(setError(""));

    if (!name || !phone || !agree) {
      return dispatch(setError(t("server_error.fields")));
    }

    const resultAction = await dispatch(
      callRequest({name, phone, email, time}),
    );

    if (callRequest.fulfilled.match(resultAction)) {
      dispatch(clearForm());
      openPopup(<SuccessSendPopup />);
    } else {
      dispatch(setError(t("server_error.submit_data")));
    }
  };

  // const getBrowserCountry = () => {
  // 	const language = navigator.language || navigator.userLanguage
  // 	const country = language.split('-')[1] || 'US'

  // 	return country.toLowerCase()
  // }

  useEffect(() => {
    dispatch(setError(""));
  }, [name, phone, email, time, agree]);

  useEffect(() => {
    return () => {
      dispatch(clearForm());
    };
  }, []);

  return (
    <div className={styles.call}>
      <H3>{t("popup.call.title")}</H3>

      <form
        onSubmit={handleSubmit}
        className={styles.callForm}
      >
        <div className={styles.callInput}>
          <RootInput
            width={376}
            label={t("input.name")}
            type={"text"}
            value={name}
            required
            onChange={(e) => dispatch(setName(e.target.value))}
            disabled={status === "loading" && true}
          />
        </div>

        <div className={styles.callInputPhone}>
          <RootDesc>
            <b>{t("input.phone")}</b>
          </RootDesc>

          <PhoneInput
            localization={switchLanguage(language)}
            searchPlaceholder={t("input.phone_search")}
            disableSearchIcon
            enableSearch
            country={language === "ru" ? "ru" : "gb"}
            value={phone}
            onChange={(number) => dispatch(setPhone(number))}
            inputProps={{
              name: "phone",
              required: true,
            }}
            disabled={status === "loading" && true}
          />
        </div>

        <div className={styles.callInput}>
          <RootInput
            placeholder={t("input.optional")}
            width={376}
            label={t("input.time")}
            type={"text"}
            value={time}
            required={false}
            onChange={(e) => dispatch(setTime(e.target.value))}
            disabled={status === "loading" && true}
          />
        </div>

        <div className={styles.callInput}>
          <RootInput
            placeholder={t("input.optional")}
            width={376}
            label={"Email"}
            type={"email"}
            value={email}
            required={false}
            onChange={(e) => dispatch(setEmail(e.target.value))}
            disabled={status === "loading" && true}
          />
        </div>

        <div className={styles.callCheckbox}>
          <RootCheckbox
            fontSize={14}
            checked={agree}
            onChange={(e) => dispatch(setAgree(e.target.checked))}
            label={
              <>
                {t("input.privacy_checkbox_label")}{" "}
                <Link
                  onClick={() => closePopup()}
                  to={"/privacy"}
                >
                  {t("input.privacy_checkbox_link")}
                </Link>
              </>
            }
          />
        </div>

        <RootButton
          txt={t("button.submit")}
          type={"submit"}
          disabled={!name || !phone || !agree || status === "loading"}
        />

        {error !== "" && (
          <FormError
            error={error}
            bottom={105}
          />
        )}

        {status === "loading" && (
          <Spinner
            width={50}
            height={50}
          />
        )}
      </form>
    </div>
  );
};
